<template>
    <div class="size-controlmy">
        <div class="story-media-head">
            <div class="tour-settings-content">
                <md-button class="md-icon-button close-tour-settings" @click="toggleShowSettings(false)">
                    <md-icon title="Close">clear</md-icon>
                </md-button>
                <div class="media-title">
                    <h2>Story Media Files</h2>
                </div>
                <div class="md-tabs">
                    <section class="media-section ng-scope">
                        <div class="text-pad">
                            <div class="line-item" v-for="(entry, index) in storyFiles" :key="index">
                                <div class="line-item title-line">
                                    <div class="left-item" v-if="entry.name =='SHOWMORE'">
                                        <div class="media-titleCopy">
                                            <h2> More Story Media Files</h2>
                                        </div>
                                    </div>
                                    <div class="left-item" v-else>
                                        {{ entry.name.substring(0, 45) }}
                                    </div>
                                    <div class="right-item">
                                        <div class="el lock-el" ng-show="item.lock" v-if="entry.name !='SHOWMORE'">
                                            <span v-if="entry.filetype == 1">
                                                <md-icon class="vid-icon" title="This story has video">videocam</md-icon>
                                            </span>
                                            <md-icon v-if="entry.exists === 1" title="File is assigned correctly" class="green-color">done</md-icon>
                                            <md-icon v-else-if="entry.exists === 0" title="File is not in your library" class="red-color">cancel</md-icon>
                                            <md-icon v-else title="File is assigned to another Tour" class="green-color">done</md-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState, mapActions} from 'vuex';

export default {
  computed: {
    ...mapState({
      storyFiles: state => state.triggers.storyFiles
    })
  },
  methods: {
    ...mapActions('editor', ['toggleShowSettings'])
  }
};
</script>
<style lang="scss">
.size-controlmy {
    width: 60% !important;
    height: 100% !important;
}

.no-pad {
    padding: 0px !important;
}

.text-pad {
    padding-right: 16px;
    padding-left: 16px;
}

.media-title {
    padding: 16px;
}

.media-titleCopy {
    padding-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TriggerStoryList.vue